import script from "./machine.vue?vue&type=script&lang=ts&setup=true"
export * from "./machine.vue?vue&type=script&lang=ts&setup=true"

import "./machine.vue?vue&type=style&index=0&id=d7842b20&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7842b20"]])

export default __exports__